import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const notificationChannelEnum = createEnum({
    INBOX: ['INBOX', '站内信'],
    SMS: ['SMS', '短信'],
    EMAIL: ['EMAIL', '邮件'],
    WECOM: ['WECOM', '企业微信'],
    DINGTALK: ['DINGTALK', '钉钉'],
    FEISHU: ['FEISHU', '飞书'],
    WECHAT: ['WECHAT', '微信'],
});
export const NOTIFICATION_CHANNELS = enumValues(notificationChannelEnum);
export const NOTIFICATION_CHANNEL_LABEL_MAP = enumLabelMap(notificationChannelEnum);
export const notificationTypeEnum = createEnum({
    NOTICE: ['NOTICE', '通知', 'blue'],
    BUSINESS: ['BUSINESS', '业务', 'green'],
    ALERT: ['ALERT', '告警', 'red'],
});
export const NOTIFICATION_TYPES = enumValues(notificationTypeEnum);
export const NOTIFICATION_TYPE_LABEL_MAP = enumLabelMap(notificationTypeEnum);
export const notificationLogStatusEnum = createEnum({
    PENDING: ['PENDING', '待发送', 'default'],
    SENT: ['SENT', '已发送', 'green'],
    FAILED: ['FAILED', '发送失败', 'red'],
    RECALLED: ['RECALLED', '已撤回', 'orange'],
});
export const NOTIFICATION_LOG_STATUSES = enumValues(notificationLogStatusEnum);
export const NOTIFICATION_LOG_STATUS_LABEL_MAP = enumLabelMap(notificationLogStatusEnum);
export const notificationPriorityEnum = createEnum({
    URGENT: ['URGENT', '紧急', 'red'],
    HIGH: ['HIGH', '高', 'orange'],
    NORMAL: ['NORMAL', '普通', 'blue'],
    LOW: ['LOW', '低', 'default'],
});
export const NOTIFICATION_PRIORITIES = enumValues(notificationPriorityEnum);
export const NOTIFICATION_PRIORITY_LABEL_MAP = enumLabelMap(notificationPriorityEnum);
export const notificationStatusEnum = createEnum({
    PENDING: ['PENDING', '待处理', 'orange'],
    DONE: ['DONE', '已处理', 'green'],
    CANCELLED: ['CANCELLED', '已取消', 'default'],
});
export const NOTIFICATION_STATUSES = enumValues(notificationStatusEnum);
export const NOTIFICATION_STATUS_LABEL_MAP = enumLabelMap(notificationStatusEnum);
export const messageHandleStatusEnum = createEnum({
    NONE: ['NONE', '无需处理', 'default'],
    PENDING: ['PENDING', '待处理', 'orange'],
    DONE: ['DONE', '已处理', 'green'],
    SKIPPED: ['SKIPPED', '已跳过', 'default'],
});
export const MESSAGE_HANDLE_STATUSES = enumValues(messageHandleStatusEnum);
export const MESSAGE_HANDLE_STATUS_LABEL_MAP = enumLabelMap(messageHandleStatusEnum);
export const messageInboxTypeEnum = createEnum({
    MESSAGE: ['MESSAGE', '消息', 'green'],
    TODO: ['TODO', '待办', 'red'],
});
export const MESSAGE_INBOX_TYPES = enumValues(messageInboxTypeEnum);
export const MESSAGE_INBOX_TYPE_LABEL_MAP = enumLabelMap(messageInboxTypeEnum);
//# sourceMappingURL=notification.js.map